import { useCallback, useEffect, useState, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { Button, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useHistory } from "react-router-dom";
import { loginRequestAction, setUserInfoAction } from "redux/reducers/user";
import { Cookies, useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { login, setAppData } from "assets/js/apphandle";
import { setInitCookies } from "assets/js/common";

const useStyles = makeStyles((theme) => ({
  container: {
    "& .h3": {
      marginTop: "38px",
    },
  },
}));

export default function JoinComplete(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const cookies = new Cookies();

  let cookieExpires = new Date();
  cookieExpires.setDate(cookieExpires.getDate() + 180);

  const { user } = useSelector((state) => state.join);
  const {
    userInfo,
    loginFail,
    loginFailReason,
    loginSuccess,
    loginResponseData,
  } = useSelector((state) => state.user);

  const goLogin = () => {
    let form = {
      grantType: "cert",
      username: null,
      password: null,
      ci: user.ci,
    };
    dispatch(loginRequestAction(form));
  };

  const loginReturnFunc = () => {
    props.history.push("/");
  };

  const setAppReturnFunc = () => {
    const myDecodedToken = jwt_decode(loginResponseData.accessToken);
    login(myDecodedToken, loginReturnFunc);
  };

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: false, title: "회원가입", menu: false }));
  }, [init]);

  useEffect(() => {
    if (loginSuccess) {
      const myDecodedToken = jwt_decode(loginResponseData.accessToken);

      dispatch(setUserInfoAction(myDecodedToken));
      axios.defaults.headers.Authorization = `${loginResponseData.tokenType} ${
        loginResponseData.accessToken
      }`;

      let cookieExpires = new Date();
      cookieExpires.setDate(cookieExpires.getDate() + 180);

      setInitCookies("expires", cookieExpires);

      axios.get("/api/mb/member/my-info").then((res) => {
        let member = res.data.data.member;
        setInitCookies(
          "favInfo",
          JSON.stringify({
            defaultTp: member.mainTp || 1, //설정에서 세팅하는 tp
            visibleTp: member.mainTp || 1, //메인 화면에서 변경시키는 tp
            favMk: member.favMk,
            favMt: member.favMt,
          })
        );
        // cookies.set(
        //   "favInfo",
        //   {
        //     defaultTp: member.mainTp || 1, //설정에서 세팅하는 tp
        //     visibleTp: member.mainTp || 1, //메인 화면에서 변경시키는 tp
        //     favMk: member.favMk,
        //     favMt: member.favMt,
        //   },
        //   {
        //     path: "/",
        //     expires: cookieExpires,
        //   }
        // );
      });
      setInitCookies(
        "X-AUTH-TOKEN",
        `${loginResponseData.tokenType} ${loginResponseData.accessToken}`
      );
      // cookies.set(
      //   "X-AUTH-TOKEN",
      //   `${loginResponseData.tokenType} ${loginResponseData.accessToken}`,
      //   {
      //     path: "/",
      //     expires: cookieExpires,
      //   }
      // );
      setInitCookies("X-REFRESH-TOKEN", loginResponseData.refreshToken);
      // cookies.set("X-REFRESH-TOKEN", `${loginResponseData.refreshToken}`, {
      //   path: "/",
      //   expires: cookieExpires,
      // });
      setInitCookies("no", myDecodedToken.no);
      // cookies.set("no", myDecodedToken.no, {
      //   path: "/",
      //   expires: cookieExpires,
      // });

      if (loginResponseData.autoToken) {
        setInitCookies("autoToken", loginResponseData.autoToken);
        // cookies.set("autoToken", `${loginResponseData.autoToken}`, {
        //   path: "/",
        //   expires: cookieExpires,
        // });
      }
      setInitCookies("checked", cookies.get("checked") || "true");

      props.history.push("/");
    }
  }, [loginSuccess]);

  window.appBackKeyHandle = () => {
    history.replace("/");
  };

  return (
    <div className={"layout-flex " + classes.container}>
      <div className="layout-body join-body">
        <h3 className="h3">
          메가마트 회원가입이
          <br />
          완료되었습니다
        </h3>
        <Typography className="info-txt" mt={3}>
          다양한 혜택을 만나보세요!
        </Typography>

        <Box className="illust" mt={20}>
          <img
            src={`${process.env.PUBLIC_URL}/images/img/illustjoin-complete.svg`}
          />
        </Box>
      </div>

      <div className="layout-footer">
        <div className="layout-link">
          <Button variant="contained" color="primary" onClick={goLogin}>
            메인으로
          </Button>
        </div>
      </div>
    </div>
  );
}
